import { type ReactNode, useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import type { Tier } from '../hooks/use-pricing-table';
import type { PricingRange } from '@/hooks/use-pricing-ranges';
import type { RangeFormMode } from '../hooks/use-range-submit';
import type { RangeFormState } from './range-form-fields';

const DEFAULT_TIERS: Tier[] = [
  { min: 1, max: 19, price_per_lead: 0.15 },
  { min: 20, max: null, price_per_lead: 0.2 },
];

export const EMPTY_FORM: RangeFormState = {
  rangeMin: '0',
  rangeLabel: '',
  tiers: DEFAULT_TIERS,
};

function fromRange(r: PricingRange): RangeFormState {
  return {
    rangeMin: String(r.range_min),
    rangeLabel: r.range_label,
    tiers: r.tiers,
  };
}

export function useFormState(mode: RangeFormMode | null) {
  const [state, setState] = useState<RangeFormState>(EMPTY_FORM);
  useEffect(() => {
    if (!mode) return;
    setState(mode.kind === 'create' ? EMPTY_FORM : fromRange(mode.range));
  }, [mode]);
  return [state, setState] as const;
}

export function ErrorList({ errors }: { errors: string[] }): ReactNode {
  if (!errors.length) return null;
  return (
    <ul className="text-xs text-error">
      {errors.map((e, i) => (
        <li key={i}>{e}</li>
      ))}
    </ul>
  );
}

export type ActionsProps = {
  onClose: () => void;
  onSubmit: () => void;
  disabled: boolean;
  isPending: boolean;
};

export function ModalActions(p: ActionsProps): ReactNode {
  return (
    <div className="mt-md flex justify-end gap-sm">
      <Button variant="ghost" onClick={p.onClose}>
        Cancelar
      </Button>
      <Button onClick={p.onSubmit} disabled={p.disabled}>
        {p.isPending ? 'Guardando...' : 'Guardar'}
      </Button>
    </div>
  );
}

export type FormBodyProps = ActionsProps & {
  state: RangeFormState;
  setState: (s: RangeFormState) => void;
  isEdit: boolean;
  errors: string[];
};
